import { PermisoService } from '../../services/permiso.service';
import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, Validators, FormGroup, UntypedFormGroup, } from '@angular/forms';
import { IpPublicService } from '../../../../services/ip-public.service';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { Subject, forkJoin, map } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ElementoNivelPermisoService } from '../../services/elemento.nivel.permiso.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { AplicacionesService } from '../../services/aplicaciones.service';
import { RiesgosService } from 'src/app/modulos/elementos-plan/services/riesgos.service';
import { IndicadoresService } from 'src/app/modulos/elementos-plan/services/indicadores.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AmbienteService } from './../../../catalogos-admin/services/ambiente.service';
import { ObjetivoService } from '../../../elementos-plan/services/objetivo.service';
import { ProyectoService } from 'src/app/modulos/elementos-plan/services/proyecto.service';
import { ProcesoService } from 'src/app/modulos/elementos-plan/services/proceso.service';
import { LineaAccionService } from 'src/app/modulos/elementos-plan/services/linea-accion.service';
import { PlanAccionService } from 'src/app/modulos/elementos-plan/services/plan.accion.service';
import { EstrategiaObjetivoService } from 'src/app/modulos/elementos-plan/services/estrategia-objetivo.service';

@Component({
  selector: 'app-elementos-nivel-permiso',
  templateUrl: './elementos.nivel.permiso.component.html',
  styleUrls: ['./elementos.nivel.permiso.component.scss'],
})
export class ElementoNivelPermisoComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  breadCrumbItems = [
    { label: 'Administración Sistema' },
    { label: 'Catálogos' },
    { label: 'Permisos niveles elementos', active: true },
  ];

  public formPermiso!: UntypedFormGroup;
  public formPermisoElementos!: UntypedFormGroup;
  public formSubmitted = false;
  public ipAddress!: string;
  public sprRiesgoIndicador!: string;
  public sprElementoConsultar!: string;
  public idSprUsuario!: number;
  public idSprPlanAnio!: number;
  public idSprAmbiente!: number;
  private currentUser!: any;
  public idSprElementoNivelPermiso: number = 0;
  public stringSelectRiesgoIndicador: string;
  public idSprElemento: number = 0;
  public idSprAmbienteSelected: number = 0;
  public idSprIndicadorSelected: number = 0;
  public idSprRiesgoSelected: number = 0;
  public idSprNivelSelected: number = 0;
  public idSprNivelAmbienteParaItem: number = 0;
  public idSprAplicacionIndicadores: number = 0;
  public idSprAplicacionRiesgos: number = 0;
  public allowSave: boolean = true;
  public allowSave2: boolean = false;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public elementosIdicadores: any[] = [];
  public elementosIdicadoresNivelN5: any[] = [];
  public elementosRiesgos: any[] = [];
  public elementosRiesgosNivelN5: any[] = [];
  public dataElementosStatic: any[] = [];
  public dataEventAplicacion: any = [];

  public dataElementosNivelesPermisos: any[] = [];
  public dataMapeadaElementosNivelesPermisos: any[] = [];
  public dataAmbientesNiveles: any[] = [];
  public dataIndicadorRiesgo: any[] = [];
  public dataNiveles: any[] = [];
  public dataAmbientes: any[] = [];
  public dataAplicaciones: any[] = [];
  public dataIndicadores: any[] = [];
  public dataIndicadoresRiesgos: any[] = [];
  public dataRiesgos: any[] = [];
  public nameModal: string = 'modalNewEdit';
  public nameApp = 'ELEMENTOS NIVELES PERMISOS';
  public dataObjetivos: any[] = [];
  public dataEstrategiasObjetivos: any[] = [];
  public dataLineasAccion: any[] = [];
  public dataRiesgosLineasAccion: any[] = [];
  public dataIndicadoresLineasAccion: any[] = [];
  public activaPermNiveles: boolean = true;
  public activaPermElementos: boolean = true;
  public permNivel: boolean = false;
  public permElemento: boolean = false;
  public activarFormEditar: boolean = true;
  currentUserRedux: UsuarioRedux = null;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private elementosNivelesPermisosService: ElementoNivelPermisoService,
    private alert: AlertService,
    private permisoService: PermisoService,
    private nivelesService: ComunService,
    private aplicacionesService: AplicacionesService,
    private riesgosService: RiesgosService,
    private indicadoresService: IndicadoresService,
    private objetivoService: ObjetivoService,
    private ambientesService: AmbienteService,
    private ip: IpPublicService,
    public modal: ModalService,
    private changeDetector: ChangeDetectorRef,
    private store: Store<AppState>,
    private proyectoService: ProyectoService,
    private procesoService: ProcesoService,
    private planAccionService: PlanAccionService,
    private lineaAccionService: LineaAccionService,
    private estrategiaObjetivoService: EstrategiaObjetivoService
  ) {
    this.selectItems = [
      { value: ' ', label: 'Seleccione opción' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.elementosIdicadores = [
      { value: 'Objetivos', label: 'Objetivos' },
      { value: 'Proyectos', label: 'Proyectos' },
      { value: 'Procesos', label: 'Procesos' },
      { value: 'LineasAccion', label: 'Lineas de Accion' },
    ];

    this.elementosIdicadoresNivelN5 = [
      { value: 'Objetivos', label: 'Objetivos' },
      { value: 'PlanesAccion', label: 'Planes  de acción' },
      { value: 'Proyectos', label: 'Proyectos' },
      { value: 'Procesos', label: 'Procesos' },
    ];
    this.elementosRiesgos = [
      { value: 'Objetivos', label: 'Objetivos' },
      { value: 'LineasAccion', label: 'Lineas de acción' },
      { value: 'Proyectos', label: 'Proyectos' },
    ];

    this.elementosRiesgosNivelN5 = [
      { value: 'Objetivos', label: 'Objetivos' },
      { value: 'PlanesAccion', label: 'Planes de acción' },
      { value: 'Proyectos', label: 'Proyectos' },
    ];

    this.idSprAplicacionIndicadores = this.constant.INDICADORES;
    this.idSprAplicacionRiesgos = this.constant.RIESGOS;
  }

  get permisoForm() {
    return this.formPermiso.controls;
  }
  get permisoElementoForm() {
    return this.formPermisoElementos.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  setForm() {
    this.formPermiso = this.fb.group({
      idSprElementoNivelPermiso: [],
      idSprNivel: [],
      idSprAplicacion: [],
      comentario: [],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      estado: [' ', [Validators.required]],
    });

    this.formPermisoElementos = this.fb.group({
      idSprElementoNivelPermiso: [],
      idSprNivel: [],
      //idSprNivel: [],
      idSprAmbiente: [],
      idSprAplicacion: [],
      //idSprAplicacion: [],
      idSprAmbienteRiesgoIndicador: [],
      idSprELemento: [],
      comentario: [],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      estado: [' ', [Validators.required]],
      nombrePermElemento: [],
    });
  }
  ngOnInit(): void {
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
      //this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      //this.idSprPlanAnio = response.ambienteSeleccionado.idSprAmbiente;
    });
    this.store.select('globalApp').subscribe((response) => {
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
    });
    this.getIpPublic();
    this.initApp();
  }

  initApp() {
    this.listDataElementosNivelesPermisos();
    this.setDataTable();
    this.setForm();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  listDataElementosNivelesPermisos() {
    forkJoin([
      this.elementosNivelesPermisosService.list(),
      this.indicadoresService.list(),
      this.aplicacionesService.list(`?filtro=${ConstantsCatalogosIdService.ID_FILTRO_ELEMENTO_PLAN}`),
      this.riesgosService.list(),
      this.nivelesService.list(`?spr_idSprComun= ${ConstantsCatalogosIdService.ID_COMUNES_NIVELES}`),
      this.ambientesService.list(),
    ]).pipe(
      map(
        ([
          elemntosNivelPermisos,
          indicadores,
          aplicaicones,
          riesgos,
          niveles,
          ambientes,
        ]) => {
          this.dataElementosNivelesPermisos = elemntosNivelPermisos;
          this.dataIndicadores = indicadores;
          this.dataAplicaciones = aplicaicones;
          this.dataRiesgos = riesgos;
          this.dataNiveles = niveles;
          this.dataAmbientes = ambientes;
          this.setDataMapeo();
          this.reDrawDataTable();
        }
      )
    ).subscribe();
  }

  itemElementosDinamic() {
    let itemElementos: any = [];
    let dataItemElementos: any = [];
    for (let i = 0; i < this.dataAplicaciones.length; i++) {
      if (this.dataAplicaciones[i].descripcion == 'Indicador' || this.dataAplicaciones[i].descripcion == 'Riesgo') {
        itemElementos = {
          idSprAplicacion: this.dataAplicaciones[i].idSprAplicacion,
          nombre: this.dataAplicaciones[i].nombre,
          descripcion: this.dataAplicaciones[i].descripcion,
          estado: this.dataAplicaciones[i].estado,
        };
        dataItemElementos.push(itemElementos);
      }
    }
    this.dataIndicadoresRiesgos = dataItemElementos;
  }

  changeNivel(e: any) {
    this.getAmbientes(e.target.value);
  }

  getAmbientes(idSprNivelSelectedParaItems: number) {
    this.idSprNivelAmbienteParaItem = idSprNivelSelectedParaItems;
    this.ambientesService.list(`?idSprNivel=${idSprNivelSelectedParaItems}`).subscribe({
      next: (responseAmbientes) => {
        this.dataAmbientesNiveles = responseAmbientes;
      },
    });
  }

  changeSelectedAmbiente(e: any) {
    this.idSprAmbienteSelected = e.target.value;
    this.idSprAmbiente = e.target.value;
  }

  changeVerificaRepetidosNivelesElementos(e: any) {
    this.verificarCandadosAbiertosPorNivel(e.target.value);
  }

  changeNivelSelected(e: any) {
    this.idSprNivelSelected = e.target.value;
  }

  // Verifica que no exista registros duplicados al crear por niveles-elementos
  verificarCandadosAbiertosPorNivel(idSprAplicacion: number) {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == this.idSprNivelSelected &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion&&
        this.dataMapeadaElementosNivelesPermisos[index].delLog == 'N') {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Ya existe un registro con  estos parametros!'
        );
      } else {
      }
    }
  }

  verificarCandadosAbiertosPorNivelEditar(idSprElementoNivelPermiso: number, idSprNivel: number, idSprAplicacion: number, estadoEdit: number) {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == idSprNivel &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion &&
        this.dataMapeadaElementosNivelesPermisos[index].estado == 1 && estadoEdit == 1 &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprElementoNivelPermiso != idSprElementoNivelPermiso) {
        this.allowSave = false;
      } else {
      }
    }
  }


  verificarCandadosAbiertosPorNivelesEItems(idAplicacionRestringir: number, idSprItemRestringir: number = 0, elemento: String = '') {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      // Verifica si existe candados abiertos por niveles y elementos
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idAplicacionRestringir &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == this.idSprNivelAmbienteParaItem &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprIndicador == null && this.dataMapeadaElementosNivelesPermisos[index].idSprIndicador != null && this.dataMapeadaElementosNivelesPermisos[index].idSprRiesgo != null && this.dataMapeadaElementosNivelesPermisos[index].estado == 1) {
        this.allowSave = false;
        this.alert.warning('Atención', 'Usted tiene aperturado los candados de ' + elemento +
          ' para este nivel, por lo tanto no se puede aperturar ' + elemento + ' independientes!'
        );
      }
      // Verifica si existe creado apertura de indicadores
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprAmbiente == this.idSprAmbiente && this.dataMapeadaElementosNivelesPermisos[index].idSprIndicador == idSprItemRestringir && elemento == 'Indicador') {
        this.allowSave = false;
        this.alert.warning('Atención', 'Ya existe un registro con  estos parametros ' + elemento
        );
      }
      // Verifica si sexiste creado apertura de riesgos

      if (
        this.dataMapeadaElementosNivelesPermisos[index].idSprAmbiente == this.idSprAmbiente &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprRiesgo == idSprItemRestringir && elemento == 'Riesgo') {
        this.allowSave = false;
        this.alert.warning(
          'Atención', 'Ya existe un registro con  estos parametros ' + elemento
        );
      }
    } // Fin for
  }

  verificarCandadosAbiertosPorNivelesEItemsEditar(idSprElementoNivelPermiso: number, idSprNivel: number, idSprAplicacion: number, idSprItemRestringir: number = 0, estadoEdit: number, elemento: String = '') {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == idSprNivel &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion &&
        this.dataMapeadaElementosNivelesPermisos[index].estado == 1 && estadoEdit == 1 &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprElementoNivelPermiso != idSprElementoNivelPermiso &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprIndicador == null && elemento == 'permIndicador') {
        this.allowSave = false;
        this.alert.warning('Atención', 'Ya existe un registro con  estos parametros'
        );
      }

      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == idSprNivel &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion &&
        this.dataMapeadaElementosNivelesPermisos[index].estado == 1 && estadoEdit == 1 &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprElementoNivelPermiso != idSprElementoNivelPermiso &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprRiesgo == null && elemento == 'permRiesgos') {
        this.allowSave = false;
        this.alert.warning(
          'Atención', 'Ya existe un registro con  estos parametros'
        );
      }
    } // Fin for
  }

  changeRiesgoIndicador(e: any) {
    //Selecciona si es riesgo o idicador
    for (let i = 0; i < this.dataAplicaciones.length; i++) {
      if (this.dataAplicaciones[i].idSprAplicacion == e.target.value) {
        this.dataEventAplicacion = this.dataAplicaciones[i];
      }
    }
    this.sprRiesgoIndicador = this.dataEventAplicacion.descripcion;
    if (this.dataEventAplicacion.descripcion == 'Indicador') {
      //idSprComun 
      if (this.formPermisoElementos.value.idSprNivel == ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5) {
        this.dataElementosStatic = this.elementosIdicadoresNivelN5;
      } else {
        this.dataElementosStatic = this.elementosIdicadores;
      }
      this.verificarCandadosNivelIndicador(e.target.value);
    } else if (this.dataEventAplicacion.descripcion == 'Riesgo') {
      if (this.formPermisoElementos.value.idSprNivel == ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5) {
        this.dataElementosStatic = this.elementosRiesgosNivelN5;
      } else {
        this.dataElementosStatic = this.elementosRiesgos;
      }
      this.verificarCandadosNivelRiesgo(e.target.value);
    }

  }

  verificarCandadosNivelIndicador(idSprAplicacion: number) {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == this.idSprNivelSelected &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprIndicador == null &&
        this.dataMapeadaElementosNivelesPermisos[index].estado == 1) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Ya existe un registro con  estos parametros!'
        );
      } else {
      }
    }
  }

  verificarCandadosNivelRiesgo(idSprAplicacion: number) {
    this.allowSave = true;
    for (let index = 0; index < this.dataMapeadaElementosNivelesPermisos.length; index++) {
      if (this.dataMapeadaElementosNivelesPermisos[index].idSprNivel == this.idSprNivelSelected &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprAplicacion == idSprAplicacion &&
        this.dataMapeadaElementosNivelesPermisos[index].idSprRiesgo == null &&
        this.dataMapeadaElementosNivelesPermisos[index].estado == 1) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Ya existe un registro con  estos parametros!'
        );
      } else {
      }
    }
  }


  //Selecciona uno de los elementos para traer obj_proyectos, procesos, lineas
  changeElemento(e: any) {
    this.sprElementoConsultar = e.target.value;
    this.getDataRiesgo_elemento(e.target.value);
  }

  // Seleciona elemento final q se guardara (riesgo/indicador)
  changeIdSelectedElement(e: any) {
    let idSprRiesgoIndicadorString = e.target.value.split('*');
    if (this.sprRiesgoIndicador == 'Riesgo') {
      this.idSprIndicadorSelected = 0;
      this.idSprRiesgoSelected = parseInt(idSprRiesgoIndicadorString[0]);
      //this.verificaDuplicadoRiesgo(this.idSprRiesgoSelected);
      this.verificarCandadosAbiertosPorNivelesEItems(this.idSprAplicacionRiesgos, this.idSprRiesgoSelected, 'Riesgo');
    } else if (this.sprRiesgoIndicador == 'Indicador') {
      this.idSprRiesgoSelected = 0;
      this.idSprIndicadorSelected = parseInt(idSprRiesgoIndicadorString[1]);
      this.verificarCandadosAbiertosPorNivelesEItems(this.idSprAplicacionIndicadores, this.idSprIndicadorSelected, 'Indicador');
    }
  }

  getDataRiesgo_elemento(elemento: any) {
    this.dataIndicadorRiesgo = [];
    switch (elemento) {
      case 'Objetivos': {
        //INDICADORES/RIESGOS DE RIEGOS;
        if (this.sprRiesgoIndicador === 'Riesgo') {
          this.getRiesgosObjetivos();
        } else if (this.sprRiesgoIndicador === 'Indicador') {
          this.getIndicadoresObjetivos();
        }
        break;
      }
      case 'Proyectos': {
        //proyetos;
        if (this.sprRiesgoIndicador === 'Riesgo') {
          this.getRiesgosProyectos();
        } else if (this.sprRiesgoIndicador === 'Indicador') {
          this.getIndicadoresProyectos();
        }
        break;
      }
      case 'Procesos': {
        //PROCESOS;
        if (this.sprRiesgoIndicador === 'Riesgo') {
          this.getRiesgosProcesos();
        } else if (this.sprRiesgoIndicador === 'Indicador') {
          this.getIndicadoresProcesos();
        }
        break;
      }
      case 'LineasAccion': {
        //LINEAS ACCION;
        if (this.sprRiesgoIndicador === 'Riesgo') {
          this.getRiesgosLineasAccion();
        } else if (this.sprRiesgoIndicador === 'Indicador') {
          this.getIndicadoresLineasAccion();
        }
        break;
      }
      case 'PlanesAccion': {
        //PLANES ACCION;
        if (this.sprRiesgoIndicador === 'Riesgo') {
          this.getRiesgosPlanesAccion();
        } else if (this.sprRiesgoIndicador === 'Indicador') {
          this.getIndicadoresPlanesAccion();
        }
        break;
      }
    }
  }

  getRiesgosObjetivos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.riesgosService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`).subscribe({
              next: (resp) => {
                this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp);
              },
            });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }
  }

  getIndicadoresObjetivos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.indicadoresService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`).subscribe({
              next: (resp) => {
                this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp);
              },
            });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getRiesgosProyectos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.proyectoService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`).subscribe({
                next: (resp) => {
                  for (let index = 0; index < resp.length; index++) {
                    this.riesgosService.list(`?idSprProyecto=${resp[index].idSprProyecto}`).subscribe({
                        next: (resp) => {
                          this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp);
                        },
                      });
                  }
                  // this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp)
                },
              });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getIndicadoresProyectos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list( `?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`)
      .subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.proyectoService
              .list(`?idSprObjetivo=${resp[index].idSprObjetivo}`)
              .subscribe({
                next: (resp) => {
                  for (let index = 0; index < resp.length; index++) {
                    this.indicadoresService
                      .list(`?idSprProyecto=${resp[index].idSprProyecto}`)
                      .subscribe({
                        next: (resp) => {
                          this.dataIndicadorRiesgo =
                            this.dataIndicadorRiesgo.concat(resp);
                        },
                      });
                  }
                },
              });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getRiesgosProcesos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list( `?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.procesoService
              .list(`?idSprObjetivo=${resp[index].idSprObjetivo}`)
              .subscribe({
                next: (resp) => {
                  for (let index = 0; index < resp.length; index++) {
                    this.riesgosService
                      .list(`?idSprProceso=${resp[index].idSprProceso}`)
                      .subscribe({
                        next: (resp) => {
                          this.dataIndicadorRiesgo =
                            this.dataIndicadorRiesgo.concat(resp);
                        },
                      });
                  }
                  // this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp)
                },
              });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getIndicadoresProcesos() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.procesoService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`)
              .subscribe({
                next: (resp) => {
                  for (let index = 0; index < resp.length; index++) {
                    this.indicadoresService
                      .list(`?idSprProceso=${resp[index].idSprProceso}`)
                      .subscribe({
                        next: (resp) => {
                          this.dataIndicadorRiesgo =
                            this.dataIndicadorRiesgo.concat(resp);
                        },
                      });
                  }
                },
              });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getRiesgosLineasAccion() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (respObje) => {
          for (let index = 0; index < respObje.length; index++) {
            this.estrategiaObjetivoService.list(`?idSprObjetivo=${respObje[index].idSprObjetivo}&nivelSuperior=${'N'}`).subscribe({
              next: (respObjeEstrategia) => {
                for (let index = 0; index < respObjeEstrategia.length; index++) {
                  this.lineaAccionService.list(`?idSprEstrategia=${respObjeEstrategia[index].idSprEstrategia}`).subscribe({
                    next: (respLinea) => {
                      for (let index = 0; index < respLinea.length; index++) {
                        this.riesgosService.list(`?idSprLineaAccion=${respLinea[index].idSprLineaAccion}`).subscribe({
                          next: (respRiesgo) => {
                            this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(respRiesgo);
                          },
                        });
                      }
                    },
                  });
                }
              }
            })
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getIndicadoresLineasAccion() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (respObje) => {
          for (let index = 0; index < respObje.length; index++) {
            this.estrategiaObjetivoService.list(`?idSprObjetivo=${respObje[index].idSprObjetivo}&nivelSuperior=${'N'}`).subscribe({
              next: (respEstrategia) => {
                for (let index = 0; index < respEstrategia.length; index++) {
                  this.lineaAccionService.list(`?idSprEstrategia=${respEstrategia[index].idSprEstrategia}`).subscribe({
                    next: (respLinea) => {
                      for (let index = 0; index < respLinea.length; index++) {
                        this.indicadoresService.list(`?idSprLineaAccion=${respLinea[index].idSprLineaAccion}`).subscribe({
                          next: (respIndicador) => {
                            this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(respIndicador);
                          },
                        });
                      }
                    },
                  });
                }
              }
            })
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }



  getRiesgosPlanesAccion() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.planAccionService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`).subscribe({
              next: (resp) => {
                for (let index = 0; index < resp.length; index++) {
                  this.riesgosService.list(`?idSprPlanAccion=${resp[index].idSprPlanAccion}`).subscribe({
                    next: (resp) => {
                      this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp);
                    },
                  });
                }
              },
            });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }

  }

  getIndicadoresPlanesAccion() {
    if(this.idSprPlanAnio != null){
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbienteSelected}&idSprPlanAnio=${this.idSprPlanAnio}`).subscribe({
        next: (resp) => {
          for (let index = 0; index < resp.length; index++) {
            this.planAccionService.list(`?idSprObjetivo=${resp[index].idSprObjetivo}`).subscribe({
              next: (resp) => {
                for (let index = 0; index < resp.length; index++) {
                  this.indicadoresService.list(`?idSprPlanAccion=${resp[index].idSprPlanAccion}`).subscribe({
                    next: (resp) => {
                      this.dataIndicadorRiesgo = this.dataIndicadorRiesgo.concat(resp);
                    },
                  });
                }
              },
            });
          }
        },
      });
    }else{
      this.alert.warning(
        'Atención!',
        'Seleccionar el año de gestión'
      );
    }
  }

  setDataMapeo() {
    let dataProcess: any = [];
    this.dataMapeadaElementosNivelesPermisos = [];
    let a = 0;

    for (a = 0; a < this.dataElementosNivelesPermisos.length; a++) {
      for (let b = 0; b < this.dataNiveles.length; b++) {
        for (let c = 0; c < this.dataAplicaciones.length; c++) {
          if (this.dataElementosNivelesPermisos[a].idSprAplicacion == this.dataAplicaciones[c].idSprAplicacion &&
            this.dataElementosNivelesPermisos[a].idSprNivel == this.dataNiveles[b].idSprComun && this.dataElementosNivelesPermisos[a].idSprIndicador == null && this.dataElementosNivelesPermisos[a].idSprRiesgo == null) {
            this.dataMapeadaElementosNivelesPermisos.push({
              idSprAplicacion: this.dataAplicaciones[c].idSprAplicacion,
              nombreAplicacion: this.dataAplicaciones[c].nombre,
              idSprNivel: this.dataElementosNivelesPermisos[a].idSprNivel,
              nombreNivel: '[' + this.dataNiveles[b].nombre + ']',
              fechaInicio: this.dataElementosNivelesPermisos[a].fechaInicio,
              fechaFin: this.dataElementosNivelesPermisos[a].fechaFin,
              idSprElementoNivelPermiso: this.dataElementosNivelesPermisos[a].idSprElementoNivelPermiso,
              estado: this.dataElementosNivelesPermisos[a].estado,
              comentario: this.dataElementosNivelesPermisos[a].comentario,
              idSprAmbiente: this.dataElementosNivelesPermisos[a].idSprAmbiente,
              //idSprRiesgo: '---',
              nombreRiesgo: '---',
              nombreIndicador: '---',
              ambienteRiesgo: '---',
              ambienteIndicador: '---',
              nombrePermNivel: 'permNiveles',
            });
          }
        }
      }
      for (let c = 0; c < this.dataRiesgos.length; c++) {
        for (let d = 0; d < this.dataAmbientes.length; d++) {
          if (this.dataElementosNivelesPermisos[a].idSprRiesgo == this.dataRiesgos[c].idSprRiesgo &&
            this.dataElementosNivelesPermisos[a].idSprAmbiente == this.dataAmbientes[d].idSprAmbiente) {
            this.dataMapeadaElementosNivelesPermisos.push({
              idSprRiesgo: this.dataRiesgos[c].idSprRiesgo,
              fechaInicio: this.dataElementosNivelesPermisos[a].fechaInicio,
              fechaFin: this.dataElementosNivelesPermisos[a].fechaFin,
              idSprElementoNivelPermiso: this.dataElementosNivelesPermisos[a].idSprElementoNivelPermiso,
              estado: this.dataElementosNivelesPermisos[a].estado,
              comentario: this.dataElementosNivelesPermisos[a].comentario,
              ambienteRiesgo: '[' + this.dataAmbientes[d].nombreUnidad + ']: ' + this.dataRiesgos[c].nombre,
              idSprAmbiente: this.dataElementosNivelesPermisos[a].idSprAmbiente,
              idSprNivel: this.dataElementosNivelesPermisos[a].idSprNivel,
              idSprAplicacion: this.dataElementosNivelesPermisos[a].idSprAplicacion,
              idSprELemento: this.dataElementosNivelesPermisos[a].idSprRiesgo,
              // idSprNivel: '---',
              nombreNivel: '',
              nombreIndicador: '---',
              nombreAplicacion: 'RIESGOS',
              ambienteIndicador: '---',
              nombrePermElemento: 'permRiesgos',
            });
          }
        }
      }

      for (let c = 0; c < this.dataIndicadores.length; c++) {
        for (let e = 0; e < this.dataAmbientes.length; e++) {
          if (this.dataElementosNivelesPermisos[a].idSprIndicador == this.dataIndicadores[c].idSprIndicador &&
            this.dataElementosNivelesPermisos[a].idSprAmbiente == this.dataAmbientes[e].idSprAmbiente) {
            this.dataMapeadaElementosNivelesPermisos.push({
              idSprIndicador: this.dataIndicadores[c].idSprIndicador,
              fechaInicio: this.dataElementosNivelesPermisos[a].fechaInicio,
              fechaFin: this.dataElementosNivelesPermisos[a].fechaFin,
              idSprElementoNivelPermiso: this.dataElementosNivelesPermisos[a].idSprElementoNivelPermiso,
              estado: this.dataElementosNivelesPermisos[a].estado,
              comentario: this.dataElementosNivelesPermisos[a].comentario,
              ambienteIndicador: '[' + this.dataAmbientes[e].nombreUnidad + ']: ' + this.dataIndicadores[c].nombre,
              idSprAmbiente: this.dataElementosNivelesPermisos[a].idSprAmbiente,
              idSprNivel: this.dataElementosNivelesPermisos[a].idSprNivel,
              idSprAplicacion: this.dataElementosNivelesPermisos[a].idSprAplicacion,
              idSprELemento: this.dataElementosNivelesPermisos[a].idSprIndicador,
              nombreNivel: '',
              idSprRiesgo: '---',
              nombreRiesgo: '---',
              nombreAplicacion: 'INDICADORES',
              ambienteRiesgo: '---',
              nombrePermElemento: 'permIndicador',
            });
          }
        }
      }
    }
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSubmit() {
    if (this.sprRiesgoIndicador === 'Riesgo') {
      this.formPermiso.value.idSprRiesgo = this.idSprRiesgoSelected;
      if (
        !this.formPermiso.value.idSprRiesgo &&
        !this.formPermiso.value.idSprAmbiente
      ) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Verifique las advertencias emitidas!.'
        );
      }
    } else if (this.sprRiesgoIndicador === 'Indicador') {
      this.formPermiso.value.idSprIndicador = this.idSprIndicadorSelected;
      if (
        !this.formPermiso.value.idSprIndicador &&
        !this.formPermiso.value.idSprAmbiente
      ) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Verifique las advertencias emitidas!..'
        );
      }
    }

    this.formSubmitted = true;
    this.formPermiso.value.usuario = this.idSprUsuario;
    this.formPermiso.value.ip = this.ipAddress;

    if (!this.formPermiso.invalid) {
      if (
        this.formPermiso.value.idSprElementoNivelPermiso == null ||
        this.formPermiso.value.idSprElementoNivelPermiso == ''
      ) {
        if (this.allowSave) {
          this.elementosNivelesPermisosService.create(this.formPermiso.value)
            .subscribe(
              (resp) => {
                this.formPermiso.reset();
                this.initApp();
                this.modal.close();
                this.alert.createOk();
              },
              (err) => {
                this.alert.createError();
              }
            );
        } else {
          this.alert.warning(
            'Atención!',
            'No es posible duplicar registros, verifique las advertencias emitidas!'
          );
        }
      } else {
        this.verificarCandadosAbiertosPorNivelEditar(this.formPermiso.value.idSprElementoNivelPermiso, this.formPermiso.value.idSprNivel, this.formPermiso.value.idSprAplicacion, this.formPermiso.value.estado);
        if (this.allowSave) {
          let dataUpdate = {
            idSprElementoNivelPermiso: this.formPermiso.value.idSprElementoNivelPermiso,
            fechaInicio: this.formPermiso.value.fechaInicio,
            fechaFin: this.formPermiso.value.fechaFin,
            comentario: this.formPermiso.value.comentario,
            estado: this.formPermiso.value.estado,
            usuario: this.idSprUsuario,
            ip: this.ipAddress,
          };

          this.elementosNivelesPermisosService.update(dataUpdate).subscribe(
            (resp) => {
              this.formPermiso.reset();
              this.initApp();
              this.modal.close();
              this.alert.updateOk();
            },
            (err) => {
              this.alert.updateError();
            }
          );
        } else {
          this.alert.warning(
            'Atención!',
            'No es posible duplicar registros, verifique las advertencias emitidas!'
          );
        }

      }
    } else {
      return;
    }
  }

  onSubmitElementos() {
    if (this.sprRiesgoIndicador === 'Riesgo') {
      this.formPermisoElementos.value.idSprRiesgo = this.idSprRiesgoSelected;
      this.formPermisoElementos.value.idSprNivel = this.formPermisoElementos.value.idSprNivel;
      this.formPermisoElementos.value.idSprAplicacion = this.formPermisoElementos.value.idSprAplicacion;
      if (!this.formPermisoElementos.value.idSprRiesgo && !this.formPermisoElementos.value.idSprAmbiente) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Verifique las advertencias emitidas!.'
        );
      }
    } else if (this.sprRiesgoIndicador === 'Indicador') {

      this.formPermisoElementos.value.idSprIndicador = this.idSprIndicadorSelected;
      this.formPermisoElementos.value.idSprNivel = this.formPermisoElementos.value.idSprNivel;
      this.formPermisoElementos.value.idSprAplicacion = this.formPermisoElementos.value.idSprAplicacion;
      if (!this.formPermisoElementos.value.idSprIndicador && !this.formPermisoElementos.value.idSprAmbiente) {
        this.allowSave = false;
        this.alert.warning(
          'Atención!',
          'Verifique las advertencias emitidas!..'
        );
      }
    }

    this.formSubmitted = true;
    this.formPermisoElementos.value.usuario = this.idSprUsuario;
    this.formPermisoElementos.value.ip = this.ipAddress;

    if (!this.formPermisoElementos.invalid) {
      if (this.formPermisoElementos.value.idSprElementoNivelPermiso == null || this.formPermisoElementos.value.idSprElementoNivelPermiso == '') {
        if (this.allowSave) {
          this.elementosNivelesPermisosService.create(this.formPermisoElementos.value).subscribe(
            (resp) => {
              this.formPermisoElementos.reset();
              this.initApp();
              this.modal.close();
              this.alert.createOk();
            },
            (err) => {
              this.alert.createError();
            }
          );
        } else {
          this.alert.warning(
            'Atención!',
            'No es posible duplicar registros, verifique las advertencias emitidas!'
          );
        }
      } else {
        this.verificarCandadosAbiertosPorNivelesEItemsEditar(this.formPermisoElementos.value.idSprElementoNivelPermiso, this.formPermisoElementos.value.idSprNivel, this.formPermisoElementos.value.idSprAplicacion, this.formPermisoElementos.value.idSprELemento, this.formPermisoElementos.value.estado, this.formPermisoElementos.value.nombrePermElemento)

        if (this.allowSave) {
          let dataUpdate = {
            idSprElementoNivelPermiso: this.formPermisoElementos.value.idSprElementoNivelPermiso,
            fechaInicio: this.formPermisoElementos.value.fechaInicio,
            fechaFin: this.formPermisoElementos.value.fechaFin,
            comentario: this.formPermisoElementos.value.comentario,
            estado: this.formPermisoElementos.value.estado,
            usuario: this.idSprUsuario,
            ip: this.ipAddress,
          };

          this.elementosNivelesPermisosService.update(dataUpdate).subscribe(
            (resp) => {
              this.formPermisoElementos.reset();
              this.initApp();
              this.modal.close();
              this.alert.updateOk();
            },
            (err) => {
              this.alert.updateError();
            }
          );
        } else {
          this.alert.warning(
            'Atención!',
            'No es posible duplicar registros, verifique las advertencias emitidas!'
          );
        }
      }

    } else {
      return;
    }
  }

  edit(obj: any) {
    this.activarFormEditar = false;
    if (obj.nombrePermNivel == 'permNiveles') {
      this.activaPermNiveles = true
      this.activaPermElementos = false
      this.permNivel = true;
    }
    if (obj.nombrePermElemento == 'permIndicador') {
      this.activaPermNiveles = false
      this.activaPermElementos = true
      this.permElemento = true;
    }

    if (obj.nombrePermElemento == 'permRiesgos') {
      this.activaPermNiveles = false
      this.activaPermElementos = true
      this.permElemento = true;
    }

    this.openModal();
    this.formPermiso.patchValue({
      idSprElementoNivelPermiso: obj.idSprElementoNivelPermiso,
      idSprNivel: obj.idSprNivel,
      idSprAplicacion: obj.idSprAplicacion,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      comentario: obj.comentario,
      estado: obj.estado,
    });

    this.formPermisoElementos.patchValue({
      idSprElementoNivelPermiso: obj.idSprElementoNivelPermiso,
      idSprNivel: obj.idSprNivel,
      idSprAmbiente: obj.idSprAmbiente,
      idSprAplicacion: obj.idSprAplicacion,
      idSprAmbienteRiesgoIndicador: obj.idSprAmbienteRiesgoIndicador,
      idSprELemento: obj.idSprELemento,
      //idSprAplicacion: obj.idSprAplicacion,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      comentario: obj.comentario,
      nombrePermElemento: obj.nombrePermElemento,
      estado: obj.estado,
    });
  }

  delete(idRegister: number) {
    this.modal.open('delete-permisos');
    this.idDeleteRegister = idRegister;
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.elementosNivelesPermisosService
        .delete({
          idSprElementoNivelPermiso: this.idDeleteRegister,
          usuario: this.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.close();
            this.alert.deleteOk();
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    }
  }

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
    this.itemElementosDinamic();
  }

  closeModalPerm() {
    this.dataIndicadoresRiesgos = [];
    this.dataAmbientesNiveles = [];
    this.activaPermNiveles = true;
    this.activaPermElementos = true;
    this.permNivel = false;
    this.permElemento = false;
    this.activarFormEditar = true;
    this.modal.closeId(this.nameModal);
  }

  // Resetear el formulario
  onResetForm() {
    this.formSubmitted = false;
    this.formPermiso.reset();
    this.formPermisoElementos.reset();
  }
}
